import { fromFetch } from 'rxjs/fetch';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { mapManagementServiceEnvironment } from '../map-management-service-environment';
import { schedulerConfigurationSchema } from '../schemas/scheduler-configuration.schema';

/**
 * Get scheduler configuration data
 * @returns Scheduler configuration data
 */
export function getSchedulerConfiguration(this: unknown) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        mapManagementServiceEnvironment.resolve(this).schedulerConfigurationUrl,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(selectData(schedulerConfigurationSchema));
}
